<template>
    <div class="d-flex flex-column flex-fill">
        <div class="annotations-item panel-control-content d-flex flex-column flex-fill">
            <div class="row mb-3">
                <div class="col-12">
                    <div class="btn-toolbar w-100 justify-content-center" role="toolbar" aria-label="">
                        <div class="btn-group btn-block" role="group" aria-label="Actions">
                            <button
                                v-for="(action, key) in activeActions"
                                :disabled="action.disabled()"
                                :key="key"
                                :title="action.title"
                                @click.prevent="applyAction(key, $event)"
                                type="button"
                                class="btn btn-main min-w-auto mx-0"
                                data-toggle="tooltip-city"
                            >
                                <i class="" :class="action.icon"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row flex-fill">
                <div class="col">
                    <form autocomplete="off" data-vv-scope="form">
                        <div class="row">
                            <div class="col-12">
                                <MaterialInput
                                    :disabled="readonlyFormItem"
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-geometryTitle"
                                    name="geometryTitle"
                                    v-model.trim="form.geometryTitle"
                                    v-validate="''"
                                    :inputClasses="[{'is-invalid': fnHasError('geometryTitle')}]"
                                    :error="fnFirstError('geometryTitle')"
                                >
                                    Título
                                    <template #grpAppend v-if="icon">
                                        <div class="d-flex align-items-center px-2">
                                            <img :src="icon" alt="Geometry"/>
                                        </div>
                                    </template>
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="row geometries mt-3">
                            <div class="col-12">

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import {TEMPORARY_PROPERTY, IS_CIRCLE_PROPERTY, ACTION_CIRCLE} from './../AnnotationConstants';

    export default {
        name: 'AnnotationRecordItemFeatureGeometry',
        mixins: [
            GlobalMixin,
        ],
        props: {
            feature: {
                type: Object,
                required: true,
                default: () => {},
            },
            controlsConfig: {
                type: Object,
                required: true,
                default: () => {},
            },
            readonlyFormItem: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                actions: {
                    back: {
                        title: 'Voltar à Anotação',
                        icon: 'fas fa-arrow-left',
                        active: () => {return true;},
                        disabled: () => {return !this.isValidFeature;},
                    },
                    save: {
                        title: 'Salvar Geometria',
                        icon: 'fas fa-save',
                        active: () => {return true;},
                        disabled: () => {return !this.isValidFeature;},
                    },
                    cancel: {
                        title: 'Remover Geometria',
                        icon: 'fas fa-trash-alt',
                        active: () => {return this.properties[TEMPORARY_PROPERTY];},
                        disabled: () => {return false;},
                    },
                },
                originalFeature: null,
                featureSession: {
                    geometry: {},
                    properties: {},
                    style: {},
                    type: 'Feature',
                },
                form: {
                    id: null,
                    isValidFeature: true,
                    canEdit: false,
                    selected: false,
                    geometryTitle: null,
                }
            }
        },
        beforeMount () {
            this.copyValue(this.feature);
        },
        mounted() {

        },
        computed: {
            activeActions() {
                const filtered = Object.entries(this.actions).filter(([key, value]) => value.active());
                return Object.fromEntries(filtered);
            },
            title() {
                return this.form.geometryTitle;
            },
            geometry() {
                return this.featureSession.geometry || {};
            },
            properties() {
                return this.featureSession.properties || {};
            },
            geometryType() {
                return this.geometry ? this.geometry.type : null;
            },
            icon() {
                let config = this.controlsConfig;
                let type = this.geometryType ? this.geometryType.toLowerCase() : null;
                if(type){
                    type = type == 'point' && this.properties[IS_CIRCLE_PROPERTY] ? ACTION_CIRCLE.type.toLowerCase() : type;
                    let key = Object.keys(config).find(key => config[key].type.toLowerCase() == type);
                    if(key) {
                        return config[key].img || config[key].icon;
                    }
                }
                return null;
            },
            isValidFeature() {
                return !!this.properties.isValidFeature;
            },
        },
        methods: {
            copyValue (value) {
                this.featureSession = value;
                if(this.featureSession){
                    this.originalFeature = JSON.parse(JSON.stringify(this.featureSession));
                    this.form = Object.assign(this.form, this.properties);
                }
            },
            applyAction(key, evt) {
                this.hideTooltip();
                switch(key) {
                    case 'save':
                        this.saveGeometry();
                        break;
                    case 'back':
                        this.closeGeometry();
                        break;
                    case 'cancel':
                        this.cancelGeometry();
                        break;
                };
            },
            saveGeometry: function() {
                if(this.isValidFeature) {
                    this.featureSession.properties = Object.assign(this.featureSession.properties, this.form);
                    this.$emit('save', this.featureSession);
                }
            },
            closeGeometry(update=true) {
                if(this.isValidFeature) {
                    this.featureSession = Object.assign(this.featureSession, this.originalFeature);
                    this.$emit('back', this.featureSession);
                }
            },
            cancelGeometry(update=true) {
                this.$emit('back', this.originalFeature);
            },
        },
        watch: {
            feature: {
                immediate: false,
                deep: true,
                handler: function(value, oldValue) {
                    this.copyValue(value);
                }
            },
            form: {
                immediate: false,
                deep: true,
                handler: function(value, oldValue) {
                    this.feature.properties = Object.assign(this.feature.properties, this.form);
                }
            }
        },
    }
</script>

<style scoped lang="scss">

</style>